import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { firstValueFrom, forkJoin } from 'rxjs';
import { InputOtpModule } from 'primeng/inputotp';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormGroupErrorMessageComponent, SvgLoaderComponent,  Utils } from 'lib-base';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-escriba-token-enviado',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, InputOtpModule,
    SvgLoaderComponent,ReactiveFormsModule, FormGroupErrorMessageComponent],
  template: `
    <section>
      <p-dialog [(visible)]="displayDialog" [modal]="true"
                [autoZIndex]="true" [draggable]="false" [resizable]="false"
                [closable]="false"
                [breakpoints]="{'2000px': '686px', '1900px': '686px', '1700px': '686px',
               '1400px': '686px', '960px': '70vw', '640px': '90vw', '490px':'94vw'}" >
        <ng-template pTemplate="content">
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="flex flex-column gap-2 align-content-center align-items-center">
              <div>
                <svg-loader name="ico-token-input"/>
              </div>
              <h1 class="font-bold color-blue-2 font-23 my-0 font-principal ">
                {{ translations.header }}
              </h1>
              <span class="app-text-gray  font-bold font-18 mb-3">
                    {{ translations.subHeader }}
              </span>
              <span class="font-13 text-center app-text-gray " style="max-width:458px;">
                {{ translations.smallText }}
              </span>
              <div class="my-3">
                <p-inputOtp formControlName="token" [integerOnly]="true" [length]="tokenLength"/>
                <ng-container *ngIf="form.get('token')?.invalid && form.get('token')?.touched">
                  <app-form-group-error-message [control]="form.get('token')"/>
                </ng-container>
              </div>
              <div class="pb-2 flex gap-3">
                <p-button type="submit" [label]="btnSubmitLabel" [rounded]="true"/>
                <p-button [label]="translations.button2" [rounded]="true" (onClick)="reenviarToken()"/>
              </div>
            </div>
          </form>
        </ng-template>
        <ng-template pTemplate="footer"></ng-template>
      </p-dialog>
    </section>
  `,
  styleUrl: './escriba-token-enviado.component.scss'
})
export class EscribaTokenEnviadoComponent implements OnInit {
  @Output() onReenviarToken = new EventEmitter<void>();
  @Output() onSubmitToken = new EventEmitter<void>();
  @Input() btnSubmitLabel: string = "";

  displayDialog = false;
  translations: any = {};
  readonly tokenLength: number = 4;

  form !: FormGroup;

  constructor(private _t: TranslateService, private _fb: FormBuilder, private _ms: MessageService) {
    this.configureForm();
  }

  ngOnInit() {
    this.translate();
  }

  private async translate(): Promise<void>{
    this.translations = await firstValueFrom(forkJoin({
      header: this._t.get('components.app-escriba-token-enviado.header'),
      subHeader: this._t.get('components.app-escriba-token-enviado.sub-header'),
      smallText: this._t.get('components.app-escriba-token-enviado.small-text'),      
      button2: this._t.get('components.app-escriba-token-enviado.button2'),
      warnSummary: this._t.get('form.msg.warn-summary'),
      completeCampos: this._t.get('form.msg.complete-campos'),
    }));
  }

  configureForm() {
    this.form = this._fb.group({
      token: [null, [Validators.required, Validators.minLength(this.tokenLength), Validators.maxLength(this.tokenLength)]],
    });
  }

  showDialog() {
    this.form.reset();
    this.displayDialog = true;
  }

  hideDialog() {
    this.displayDialog = false;
  }

  reenviarToken() {
    this.onReenviarToken.emit();
  }

  onSubmit() {
    if (this.form.invalid) {
      Utils.markAllFormControlsAsTouched(this.form);
      this._ms.add({ severity: 'warn', summary: this.translations.warnSummary, detail: this.translations.completeCampos });
      return;
    }

    this.onSubmitToken.emit();    
  }
}
